var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.84 16.226 19.8 4.901q.388-.4.906-.401.517 0 .905.4.388.402.388.953t-.388.952L9.745 19.1q-.388.4-.905.401-.518 0-.906-.4l-5.561-5.747A1.26 1.26 0 0 1 2 12.401q.015-.552.404-.952.388-.402.921-.401.534 0 .922.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutline);
export default __webpack_public_path__ + "static/media/check_outline.642933eefb1e76d76cdcfe2c53d114da.svg";
export { ForwardRef as ReactComponent };